import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { SaversCarrier } from '../../types';

export const getAllSaversCarriers = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetSaversCarrier `,
  });
};

export type SaversCarrierResponse = SaversCarrier[];

export const fetchAllSaversCarriers = async (): Promise<SaversCarrierResponse> => {
  const response: AxiosResponse<SaversCarrierResponse> = await getAllSaversCarriers();
  return response.data;
};
